import { Typography } from 'antd';
import { TitleProps as AntdTitleProps } from 'antd/lib/typography/Title';
import { TextProps as AntdTextProps } from 'antd/lib/typography/Text';
import { ParagraphProps as AntdParagraphProps } from 'antd/lib/typography/Paragraph';
import { FC } from 'react';

export const Text: FC<AntdTextProps> = (props) => <Typography.Text {...props} />;

export const Paragraph: FC<AntdParagraphProps> = (props) => <Typography.Paragraph {...props} />;

export const Title: FC<AntdTitleProps> = (props) => <Typography.Title {...props} />;

export interface TitleProps extends AntdTitleProps {}
